module.exports = __webpack_public_path__ + "img/body.3969e7b9.png";